export const StarIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="33"
    height="30"
    viewBox="0 0 33 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0398 9.0568L15.1958 0.795411C15.7293 -0.265137 17.2707 -0.265137 17.8042 0.795411L21.9602 9.0568L31.2544 10.3897C32.4469 10.5608 32.9221 11.9991 32.0589 12.8241L25.3347 19.2502L26.9216 28.3285C27.1254 29.4944 25.8782 30.3834 24.8112 29.8328L16.5 25.5442L8.18875 29.8328C7.12176 30.3834 5.87454 29.4944 6.07832 28.3285L7.6652 19.2502L0.941203 12.8241C0.077875 11.9991 0.553155 10.5608 1.74563 10.3897L11.0398 9.0568Z"
      fill="currentColor"
    />
  </svg>
);
